var _defs, _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUnderline = function SvgUnderline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 350.46 20.51",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 350.46,
    y1: 10.25,
    x2: 0,
    y2: 10.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3a89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4197ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4197ca"
  })))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "rogal")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.43,4.56c-8.18.9-16.63,1.09-24.29,3.34l.13.67c3.43-.15,6.86-.26,10.27-.46Q79,6.69,103.5,5.24c20.21-1.2,40.4-2.55,60.64-3.6,19.19-1,38.41-1.8,57.7-1.61,5.12.05,10.23,0,15.35.07,22,.22,43.89,1.13,65.51,3.75C317.33,5.63,331.8,7.92,345,12.57a21.54,21.54,0,0,1,5.46,2.67,12.23,12.23,0,0,1-1.81-.07A392.18,392.18,0,0,0,308,10c-34.25-2.79-68.68-3.46-103.16-3-19.85.28-39.69.92-59.52,1.61-7.49.26-14.93,1.11-22.4,1.67q-12.76,1-25.53,1.88c-14,1-28.11,1.91-42.13,3-11.33.9-22.63,2-33.9,3.1-3.83.39-7.54,1.28-11.3,2a13,13,0,0,1-7.75-.74c-2.55-1.13-3.1-2.35-1.14-3.84a24.33,24.33,0,0,1,6-3.42c16.17-6.17,33.41-10,52.63-9.19,2.93.12,5.82.55,8.73.84Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnderline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/underline.2a9f880c.svg";
export { ForwardRef as ReactComponent };